import React from 'react';

const PartialIndicatorIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <rect x="6.5" y="10.5" width="8" height="1.5" />
  </svg>
);

export default PartialIndicatorIcon;
